/**
 * Words a typed amount may carry. A COPY of backend/app/services/locale_number_words.json (the server
 * twin's data); parseLocaleNumber.test.ts fails if the two differ. See that file's `_doc` for the rules.
 */
export const SCALE_WORDS: Readonly<Record<string, Readonly<Record<string, number>>>> = {
  "*": {
    "k": 1000
  },
  "en": {
    "thousand": 1000,
    "thousands": 1000,
    "m": 1000000,
    "mn": 1000000,
    "million": 1000000,
    "millions": 1000000,
    "b": 1000000000,
    "bn": 1000000000,
    "billion": 1000000000,
    "billions": 1000000000,
    "lakh": 100000,
    "lakhs": 100000,
    "lac": 100000,
    "lacs": 100000,
    "crore": 10000000,
    "crores": 10000000,
    "cr": 10000000
  },
  "hi": {
    "thousand": 1000,
    "m": 1000000,
    "mn": 1000000,
    "million": 1000000,
    "millions": 1000000,
    "bn": 1000000000,
    "billion": 1000000000,
    "billions": 1000000000,
    "lakh": 100000,
    "lakhs": 100000,
    "lac": 100000,
    "lacs": 100000,
    "crore": 10000000,
    "crores": 10000000,
    "cr": 10000000,
    "हज़ार": 1000,
    "हजार": 1000,
    "लाख": 100000,
    "करोड़": 10000000
  },
  "de": {
    "tsd": 1000,
    "tausend": 1000,
    "m": 1000000,
    "mio": 1000000,
    "million": 1000000,
    "millionen": 1000000,
    "mrd": 1000000000,
    "milliarde": 1000000000,
    "milliarden": 1000000000,
    "bio": 1000000000000,
    "billion": 1000000000000,
    "billionen": 1000000000000
  },
  "fr": {
    "mille": 1000,
    "m": 1000000,
    "million": 1000000,
    "millions": 1000000,
    "md": 1000000000,
    "mds": 1000000000,
    "mrd": 1000000000,
    "milliard": 1000000000,
    "milliards": 1000000000,
    "billion": 1000000000000,
    "billions": 1000000000000
  },
  "it": {
    "mille": 1000,
    "mila": 1000,
    "m": 1000000,
    "mln": 1000000,
    "milione": 1000000,
    "milioni": 1000000,
    "mld": 1000000000,
    "mrd": 1000000000,
    "miliardo": 1000000000,
    "miliardi": 1000000000
  },
  "es": {
    "mil": 1000,
    "m": 1000000,
    "mm": 1000000,
    "mill": 1000000,
    "millón": 1000000,
    "millon": 1000000,
    "millones": 1000000,
    "mil millones": 1000000000,
    "millardo": 1000000000,
    "millardos": 1000000000,
    "billón": 1000000000000,
    "billon": 1000000000000,
    "billones": 1000000000000
  },
  "pt": {
    "mil": 1000,
    "m": 1000000,
    "mi": 1000000,
    "milhão": 1000000,
    "milhao": 1000000,
    "milhões": 1000000,
    "milhoes": 1000000,
    "mil milhões": 1000000000,
    "mil milhoes": 1000000000,
    "bi": 1000000000,
    "bilhão": 1000000000,
    "bilhao": 1000000000,
    "bilhões": 1000000000,
    "bilhoes": 1000000000,
    "bilião": 1000000000000,
    "biliao": 1000000000000,
    "biliões": 1000000000000,
    "bilioes": 1000000000000
  },
  "nl": {
    "duizend": 1000,
    "m": 1000000,
    "mln": 1000000,
    "miljoen": 1000000,
    "miljoenen": 1000000,
    "mld": 1000000000,
    "mrd": 1000000000,
    "miljard": 1000000000,
    "miljarden": 1000000000
  },
  "ru": {
    "тыс": 1000,
    "тысяч": 1000,
    "тысячи": 1000,
    "тысяча": 1000,
    "млн": 1000000,
    "миллион": 1000000,
    "миллиона": 1000000,
    "миллионов": 1000000,
    "млрд": 1000000000,
    "миллиард": 1000000000,
    "миллиарда": 1000000000,
    "миллиардов": 1000000000
  },
  "tr": {
    "bin": 1000,
    "m": 1000000,
    "mn": 1000000,
    "milyon": 1000000,
    "milyar": 1000000000,
    "mr": 1000000000
  },
  "id": {
    "rb": 1000,
    "ribu": 1000,
    "jt": 1000000,
    "juta": 1000000,
    "miliar": 1000000000
  },
  "zh": {
    "千": 1000,
    "万": 10000,
    "萬": 10000,
    "百万": 1000000,
    "百萬": 1000000,
    "亿": 100000000,
    "億": 100000000
  },
  "ja": {
    "千": 1000,
    "万": 10000,
    "百万": 1000000,
    "億": 100000000
  },
  "ko": {
    "천": 1000,
    "만": 10000,
    "백만": 1000000,
    "억": 100000000
  },
  "ar": {
    "ألف": 1000,
    "الف": 1000,
    "مليون": 1000000,
    "مليار": 1000000000
  }
}

export const CURRENCY_CODES: readonly string[] = ["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHF", "CLP", "CNY", "COP", "CRC", "CUC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SLL", "SOS", "SRD", "SSP", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "UYU", "UZS", "VES", "VND", "VUV", "WST", "XAF", "XCD", "XCG", "XDR", "XOF", "XPF", "XSU", "YER", "ZAR", "ZMW", "ZWG", "ZWL"]

export const CURRENCY_WORDS: readonly string[] = ["kr", "fr", "sfr", "zł", "kč", "ft", "lei", "rp", "rs", "tl", "dh", "руб", "р", "元", "円", "원", "us$", "a$", "au$", "c$", "ca$", "hk$", "nt$", "s$", "nz$", "r$", "r"]
